var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.list && _vm.list.length > 0
    ? _c("div", { staticClass: "video-model" }, [
        _c("h3", [_vm._v("热播更新")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "video-model-list" },
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show(index),
                    expression: "show(index)",
                  },
                ],
                key: index,
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: item.playurl,
                      uigs: "out_hot_update_" + index,
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "video-model-img-h" },
                      [
                        _c("img-item", { attrs: { src: item.picurl } }),
                        _vm._v(" "),
                        item.vip === 1
                          ? _c("span", { staticClass: "tag-fee" }, [
                              _vm._v("VIP"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "tag" }, [
                          _c("span", { staticClass: "tag-info" }, [
                            _vm._v(_vm._s(item.update_info)),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "video-model-desc" }, [
                      _c("p", [_vm._v(_vm._s(item.title))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item.surtext))]),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "video-model-btn" }, [
          _c(
            "a",
            {
              attrs: { uigs: "home_hot_update_change" },
              on: { click: _vm.change },
            },
            [_c("span", { staticClass: "change" }, [_vm._v("换一换")])]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }